<p-dialog
  [style]="{ width: '80vw' }"
  id="orderAddDialog"
  [(visible)]="isVisible"
  appendTo="body"
  (visibleChange)="dialogVisibleChange($event)"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
>
  <div class="container">
    <p-header class="page-title" style="font-size: 30px">
      <span class="icon"><i class="fas fa-file-alt"></i></span
      >{{ "BillSearch.BillAdd.Header" | translate }}
    </p-header>
    <form class="detail-form" [formGroup]="addForm">
      <div class="flex align-items-center flex-wrap">
        <div class="mr-2">{{ 'BillSearch.BillAdd.ImportTable.NewLineCount' | translate }}</div>
          <p-inputNumber
            formControlName="addValue"
            [(ngModel)]="addValue"
            mode="decimal"
          ></p-inputNumber>
          <button
            pButton
            pRipple
            class="ml-2"
            label="Add"
            (click)="addBtnClick()"
          ></button>
      </div>
    </form>

    <div class="field col-6">
      <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick()"></button>
      <button
        pButton
        pRipple
        label="{{ 'Common.Button.Delete' | translate }}"
        (click)="deleteBtnClick()"
        class="p-button-secondary ml-2"
      ></button>
    </div>
    <div class="mt-2">
      <p-table
        #billAddTable
        [columns]="tableColumns"
        [value]="tableValue"
        [scrollable]="true"
        scrollHeight="500px"
        [loading]="isLoading"
        [reorderableColumns]="true"
        [resizableColumns]="true"
        [(selection)]="selectedRow"
        selectionMode="single"
        class="edittable"
        dataKey="rowId"
        editMode="row"
        styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
      >
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" style="width: 10.8vw" />
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              *ngFor="let col of columns"
              pResizableColumn
              pReorderableColumn
            >
              {{ col.header | translate }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
          <tr
            [pSelectableRow]="rowData"
            [pEditableRow]="rowData"
            (click)="onRowClick(rowData)"
          >
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <p-cellEditor *ngSwitchCase="'guiId'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      required
                      (focusout)="focusOutFunction(rowIndex)"
                      [(ngModel)]="rowData[col.field]"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'billingNo'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      required
                      (focusout)="focusOutFunction(rowIndex)"
                      [(ngModel)]="rowData[col.field]"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor
                  *ngSwitchCase="'vendorDescription'"
                  class="p-fluid"
                >
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      required
                      [(ngModel)]="rowData[col.field]"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'billType'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="billTypeOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.billTypeOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <ng-container *ngSwitchCase="'billCorp'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: billCorpOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'inOutType'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping: inOutTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-container>
                <p-cellEditor *ngSwitchCase="'carrierPaymentBy'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="carrierPaymentByOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: carrierPaymentByOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'accountCode'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="accountCodeDetailOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.accountCodeDetailOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'guiCurrency'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="currencyOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.currencyOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'guiAmount'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <p-inputNumber
                      mode="decimal"
                      [minFractionDigits]="4"
                      (focusout)="focusOutGUIAmount()"
                      [(ngModel)]="rowData[col.field]"
                    ></p-inputNumber>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | number: "1.4-4"
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'amount'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <p-inputNumber
                      mode="decimal"
                      [minFractionDigits]="4"
                      [(ngModel)]="rowData[col.field]"
                      [class]="(showTableValidationMessage(rowData[col.field], submitted) && submitted) ? ['ng-invalid', 'ng-dirty'] : []"
                    ></p-inputNumber>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | number: "1.4-4"
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'linePayCurrency'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="currencyOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.currencyOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'invoiceType'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="invoiceTypeOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.invoiceTypeOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'guiDt'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <p-calendar
                      appendTo="body"
                      dateFormat="yy-mm-dd"
                      [showTime]="true"
                      [(ngModel)]="rowData[col.field]"
                      [maxDate]="today"
                    ></p-calendar>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm"
                            : this.laasSetting.facilityTimeZone
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'guiNo'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <input
                      pInputText
                      type="text"
                      required
                      [(ngModel)]="rowData[col.field]"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'paymentMethod'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      [options]="paymentMethodOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.paymentMethodOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'termsId'">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate }}"
                      optionValue="value"
                      optionLabel="label"
                      [options]="termsIdOptions"
                      appendTo="body"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      class="p-fluid"
                    >
                    </p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | optionsMapping: this.termsIdOptions
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <p-cellEditor *ngSwitchCase="'dueDt'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <p-calendar
                      appendTo="body"
                      dateFormat="yy-mm-dd"
                      [showTime]="true"
                      [(ngModel)]="rowData[col.field]"
                    ></p-calendar>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="overflow-text">
                      {{
                        rowData[col.field]
                          | date
                            : "yyyy-MM-dd HH:mm"
                            : this.laasSetting.facilityTimeZone
                          | replaceNullWith: "-"
                      }}
                    </div>
                  </ng-template>
                </p-cellEditor>
                <ng-container *ngSwitchDefault>
                  <ng-container [ngSwitch]="col.dataType">
                    <p-cellEditor *ngSwitchCase="'date'" class="p-fluid">
                      <ng-template pTemplate="input">
                        <div class="overflow-text">
                          {{
                            rowData[col.field]
                              | date
                                : "yyyy-MM-dd"
                                : this.laasSetting.facilityTimeZone
                              | replaceNullWith: "-"
                          }}
                        </div>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <div class="overflow-text">
                          {{
                            rowData[col.field]
                              | date
                                : "yyyy-MM-dd"
                                : this.laasSetting.facilityTimeZone
                              | replaceNullWith: "-"
                          }}
                        </div>
                      </ng-template>
                    </p-cellEditor>
                    <ng-container *ngSwitchDefault class="p-fluid">
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith: "-" }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="tableColumns.length + 1">
              {{ "Common.Table.NoData" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
